import { makeAutoObservable } from "mobx";
import { QueryService } from "../services/QueryService";
export interface iQuote {
  id: number;
  text: string;
  distance: number;
}
export class Quotes {
  public data: iQuote[] = [
    {
      id: 1,
      text: "Что-то",
      distance: 0.3,
    },
  ];
  constructor() {
    makeAutoObservable(this);
  }
    /**
     * 
     * @param searchVal 
     */
  public async search(searchVal: string) {
    const res = await QueryService.postQuery("/api/admin/quotesSearch", {
      searchVal,
    });
    this.data =  res?.data.sortedQuotes;
  }
}
export const quotesGlobal = new Quotes();
